import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RegisterComponent } from './register-component/register-component.component';
import { LoginComponent } from './login-component/login-component.component';
import { HomeComponent } from './home/home.component';
import { RiskquizComponent } from './questionaire/riskquiz/riskquiz.component';
import { RiskscoreComponent } from './questionaire/riskscore/riskscore.component';
import { RegisteredThanksComponent } from './registered-thanks/registered-thanks.component';
import { MotivationquizComponent } from './questionaire/motivationquiz/motivationquiz.component';
import { HistoryComponent } from './histories/history/history.component';
import { MotivationscoreComponent } from './questionaire/motivationscore/motivationscore.component';
import { DemographyquizComponent } from './questionaire/demographyquiz/demographyquiz.component';
import { DemographyscoreComponent } from './questionaire/demographyscore/demographyscore.component';
import { AuthGuard } from './auth.guard';
import { WeightlogComponent } from './logs/weightlog/weightlog.component';
import { ActivitylogComponent } from './logs/activitylog/activitylog.component';
import { HealthlogComponent } from './logs/healthlog/healthlog.component';
import { FoodLogsComponent } from './logs/food-logs/food-logs.component';
import { LogsCardComponent } from './logs-card/logs-card.component';
import { LogsDashboardComponent } from './logs-dashboard/logs-dashboard.component';
import { ProgramgoalsComponent } from './questionaire/programgoals/programgoals.component';
import { WeightTrendComponent } from './trends/weight-trend/weight-trend.component';
import { FoodTrendComponent } from './trends/food-trend/food-trend.component';
import { FoodHistoryComponent } from './histories/food-history/food-history.component';
import { WeightHistoryComponent } from './histories/weight-history/weight-history.component';
import { ActivityplanComponent } from './logs/activityplan/activityplan.component';
import { FoodplanComponent } from './logs/foodplan/foodplan.component';
import { PlansCardComponent } from './plans-card/plans-card.component';
import { TestTableComponent } from './histories/test-table/test-table.component';
import { ActivityTrendComponent } from './trends/activity-trend/activity-trend.component';
import { LifestylequizComponent } from './questionaire/lifestylequiz/lifestylequiz.component';
import { SdohquizComponent } from './questionaire/sdohquiz/sdohquiz.component';
import { Sdohquiz2Component } from './questionaire/sdohquiz2/sdohquiz2.component';
import { ComorbidityquizComponent } from './questionaire/comorbidityquiz/comorbidityquiz.component';
import { PreferencequizComponent } from './questionaire/preferencequiz/preferencequiz.component';
import { FoodplanHistoryComponent } from './histories/foodplan-history/foodplan-history.component';
import { ActivityplanHistoryComponent } from './histories/activityplan-history/activityplan-history.component';
import { AccountDetailsComponent } from './account-details/account-details.component';
import { FoodQuizComponent } from './questionaire/food-quiz/food-quiz.component';
import { DoccardComponent } from './doccard/doccard.component';
import { DocsummaryComponent } from './doctorview/docsummary/docsummary.component';
import { DocactivitytrendComponent } from './doctorview/docactivitytrend/docactivitytrend.component';
import { DocfoodtrendComponent } from './doctorview/docfoodtrend/docfoodtrend.component';
import { DocweighttrendComponent } from './doctorview/docweighttrend/docweighttrend.component';
import { ProgramComponent } from './program/program.component';
import { CoachviewComponent } from './logs/coachview/coachview.component';
import { DeniedRegisterComponent } from './denied-register/denied-register.component';
import { RecommendPatientComponent } from './recommend-patient/recommend-patient.component';
import { PreprogramComponent } from './questionaire/preprogram/preprogram.component';
import { PhoneandemailComponent } from './questionaire/phoneandemail/phoneandemail.component';
import { RegisterprogramgoalsComponent } from './questionaire/registerprogramgoals/registerprogramgoals.component';
import { CoachclassesComponent } from './coachclasses/coachclasses.component';


const routes: Routes = [

  {
    path: 'test',
    component: TestTableComponent,
  },

  {
    path: 'register',
    component: RegisterComponent,
  },
  {
    path: 'accountDetails',
    component: AccountDetailsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'login',
    component: LoginComponent

  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [AuthGuard]

  },
  {
    path: 'riskquiz/:userId',
    component: RiskquizComponent,
    canActivate: [AuthGuard]

  },
  {
    path: 'quiz1',
    component: RiskquizComponent,
    canActivate: [AuthGuard]
  },

  {
    path: 'history',
    component: HistoryComponent,
    canActivate: [AuthGuard]
  },

  {
    path: 'foodHistory',
    component: FoodHistoryComponent,
    canActivate: [AuthGuard]
  },

  {
    path: 'weightHistory',
    component: WeightHistoryComponent,
    canActivate: [AuthGuard]
  },

  {
    path: 'testTable',
    component: TestTableComponent,
    canActivate: [AuthGuard]
  },

  {
    path: 'riskscore',
    component: RiskscoreComponent,
    canActivate: [AuthGuard]

  },
  {
    path: 'registeredThanks',
    component: RegisteredThanksComponent,

  },
  {
    path: 'registerprogramgoals',
    component: RegisterprogramgoalsComponent,
    canActivate: [AuthGuard]

  },
  {
    path: 'quiz8',
    component: MotivationquizComponent,
    canActivate: [AuthGuard]

  },
  {
    path: 'motivationscore',
    component: MotivationscoreComponent,
    canActivate: [AuthGuard]

  },
  {
    path: 'quiz2',
    component: DemographyquizComponent,
    canActivate: [AuthGuard]

  },
  {
    path: 'demographyscore',
    component: DemographyscoreComponent,
    canActivate: [AuthGuard]

  },
  {
    path: 'weightlog',
    component: WeightlogComponent,
    canActivate: [AuthGuard]
  },
   {
    path: 'activitylog',
    component: ActivitylogComponent,
    canActivate: [AuthGuard]

  },
  {
    path: 'activityplan',
    component: ActivityplanComponent,
    canActivate: [AuthGuard]

  },
  {
    path: 'foodplan',
    component: FoodplanComponent,
    canActivate: [AuthGuard]

  },

  {
    path: 'programgoals',
    component: ProgramgoalsComponent,
    canActivate: [AuthGuard]

  },
  {
    path: 'foodlog',
    component: FoodLogsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'healthlog',
    component: HealthlogComponent,
    canActivate: [AuthGuard]

  },
  {
    path: 'weighttrends',
    component: WeightTrendComponent,
    // canActivate: [AuthGuard]
  },
  {
    path: 'foodtrends',
    component: FoodTrendComponent,
    // canActivate: [AuthGuard]
  },
  {
    path: 'activitytrends',
    component: ActivityTrendComponent,
    // canActivate: [AuthGuard]
  },
  {
    path: 'activitytrends/:id',
    component: ActivityTrendComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'logs',
    component: LogsCardComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'doccard',
    component: DoccardComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'plans',
    component: PlansCardComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'foodplanHistory',
    component: FoodplanHistoryComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'activityplanHistory',
    component: ActivityplanHistoryComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'quiz3',
    component: LifestylequizComponent,
    canActivate: [AuthGuard]

  },
  {
    path: 'quiz4',
    component: FoodQuizComponent,
    canActivate: [AuthGuard]
  },

  {
    path: "quiz5",
    component: SdohquizComponent,
    canActivate: [AuthGuard]
  },

  {
    path: "sdohquiz2",
    component: Sdohquiz2Component,
    canActivate: [AuthGuard]
  },

  {
    path: "quiz6",
    component: ComorbidityquizComponent,
    canActivate: [AuthGuard]
  },

  {
    path: "quiz7",
    component: PreferencequizComponent,
    canActivate: [AuthGuard]
  },

  {
    path: 'docsummary',
    component: DocsummaryComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'docactivitytrend',
    component: DocactivitytrendComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'docfoodtrend',
    component: DocfoodtrendComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'docweighttrend',
    component: DocweighttrendComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'program',
    component: ProgramComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'coachview',
    component: CoachviewComponent,

  },
  {
    path: 'deniedRegister',
    component: DeniedRegisterComponent,
  },
  {
    path: 'recommendRegister',
    component: RecommendPatientComponent,
  },
  {
    path: 'preprogram',
    component: PreprogramComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'phoneandemail',
    component: PhoneandemailComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'coachclasses',
    component: CoachclassesComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'logs/:id',
    component: LogsCardComponent,
  },
  {
    path: 'programgoals/:id',
    component: ProgramgoalsComponent,
  },
  {
    path: '**',
    component: HomeComponent

  }
];


@NgModule({
  imports: [RouterModule.forRoot(routes,
    {enableTracing: false}
    ),
],
  exports: [RouterModule]
})
export class AppRoutingModule { }
